<template>
  <!-- <v-file-input @change="fileChanged" show-size label="Файл" v-model="file"></v-file-input> -->
  <Upload
    drag
    :before-upload="handleBefore"
    :action="actionURL"
    :on-error="handleError"
    :on-success="handleSuccess"
    :on-exceed="handleExceed"
    :disabled="false"
    :limit="100"
    :multiple="false"
    :show-file-list="false"
    class="upld-wrpr"
    :accept="dataAccept"
  >
    <slot name="trigger" />
    <!-- <el-button type="primary">Click to upload</el-button> -->
    <slot name="tip" />
  </Upload>
</template>

<style>
.upld-wrpr .el-upload {
  width: 100% !important;
}
.upld-wrpr .el-upload-dragger {
  width: 100% !important;
  height: 100% !important;
}
</style>

<script>
//import { uploader } from "@/api/media";
import { getToken } from "@/libs/util";
// import Axios from "axios";
//import Cookies from "js-cookie";

import "element-ui/lib/theme-chalk/index.css";
import { Upload } from "element-ui";
import { hasOneOf } from "@/libs/tools";
import { mapActions } from "vuex";

export default {
  name: "simpleUploader",
  components: {
    Upload
  },
  props: {
    propAccept: {
      type: String,
      default: () => ""
    },
    folderId: {
      type: Number,
      default: () => null
    },
    boxId: {
      type: Number,
      default: () => 0
    },
    objectTypeId: {
      type: Number,
      default: () => 0
    },
    mode: {
      type: Number,
      default: () => 0
    },
    objectId: {
      type: String,
      default: () => "0"
    }
  },
  data() {
    return {
      actionURL: "",
      file: null,
      fileExceedSize: 102400,
      fileExceedMsg:
        "Файл байршуулах хэмжээ их байна. Хуулах хамгийн их хэмжээ: 100мб байна.",
      dataAccept: "",
      baseURL: "https://mobcore.gosmart.mn/"
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.baseUrl != undefined &&
      this.$store.state.app.activeGroup.baseUrl != ""
    ) {
      this.baseURL = this.$store.state.app.activeGroup.baseUrl;
    }

    if (this.propAccept != "") {
      this.dataAccept = this.propAccept;
    } else {
      let _mimes = this.$store.state.app.groupSettings.filter(
        x => x.key == "uploadMimeTypes"
      );
      if (
        _mimes.length > 0 &&
        _mimes[0].value != undefined &&
        _mimes[0].value != ""
      ) {
        this.dataAccept = _mimes[0].value;
      }
    }
    this.init();
  },
  methods: {
    ...mapActions(["handleLoading"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    handleExceed() {
      //this.$Message.warning({content: this.fileExceedMsg, duration: 15});
      this.toggleBodyClass("removeClass", "dynamic-locker");
      this.uploadStart = false;
      this.$bvToast.toast("1 удаа 100-с илүү файл хуулах боломжгүй", {
        title: "Сануулга",
        autoHideDelay: 10000,
        appendToast: true,
        variant: "success",
        toaster: "b-toaster-bottom-left"
      });
    },
    handleBefore(file) {
      if (this.folderId == 0) {
        //this.$Message.warning("Файл байршуулах хавтас сонгоно уу");
        this.$bvToast.toast("Файл байршуулах хавтас сонгоно уу", {
          title: "Сануулга",
          autoHideDelay: 10000,
          appendToast: true,
          variant: "warning",
          toaster: "b-toaster-bottom-left"
        });
        return false;
      } else {
        if (file.size / 1024 > this.fileExceedSize) {
          this.$bvToast.toast(this.fileExceedMsg, {
            title: "Сануулга",
            autoHideDelay: 10000,
            appendToast: true,
            variant: "warning",
            toaster: "b-toaster-bottom-left"
          });
          return false;
        }
        this.handleLoading({ isLoading: true });
        this.toggleBodyClass("addClass", "dynamic-locker");
        this.uploadStart = true;
      }
    },
    handleError(e) {
      //console.log(e);
      this.toggleBodyClass("removeClass", "dynamic-locker");
      this.$emit("on-error", e);
    },
    handleSuccess(e) {
      //console.log(e)
      this.handleLoading({ isLoading: false });
      this.toggleBodyClass("removeClass", "dynamic-locker");
      this.uploadStart = false;
      if (e.code == 200) {
        //console.log(e);
        //this.$emit("inpit", { response: e });
        //this.$emit("on-success", { response: e });
        this.$emit("inpit", e.data.uploadedAttachmentId);
        this.$emit("on-success", e.data);

        this.$bvToast.toast("Файлыг серверт амжилттай хууллаа", {
          title: "Амжилттай",
          autoHideDelay: 2000,
          appendToast: true,
          variant: "success",
          toaster: "b-toaster-bottom-left"
        });
        // this.$Notice.success({
        //   title: "Амжилттай",
        //   desc: "Файлыг серверт амжилттай хууллаа."
        // });
      } else {
        this.$bvToast.toast(e.msg, {
          title: "Сануулга",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "error",
          toaster: "b-toaster-bottom-left"
        });
        // this.$Notice.warning({
        //   title: "Сануулга",
        //   desc: e.msg
        // });
      }
    },

    init() {
      
      if (this.hasPermission(["learningstudent"])) {
        //console.log('stepppppp1');
        if(!this.hasPermission(["learningadmin"])){
          //console.log('stepppppp2');
          this.fileExceedSize = this.$store.state.app.activeGroup.fileUploadSize.student.size;
          this.fileExceedMsg = this.$store.state.app.activeGroup.fileUploadSize.student.msg;
        }else{
          //console.log('stepppppp3');
          this.fileExceedSize = this.$store.state.app.activeGroup.fileUploadSize.default.size;
          this.fileExceedMsg = this.$store.state.app.activeGroup.fileUploadSize.default.msg;  
        }
      } else {
        this.fileExceedSize = this.$store.state.app.activeGroup.fileUploadSize.default.size;
        this.fileExceedMsg = this.$store.state.app.activeGroup.fileUploadSize.default.msg;
      }
      this.actionURL =
        this.baseURL +
        "core/uploader?boxId=" +
        this.boxId +
        "&folderId=-999" +
        "&objectTypeId=6" +
        "&objectId=0" +
        "&mode=0" +
        "&token=" +
        getToken();
      //folder selected bvl shuud select bolgoh
      //this.headers.Authorization = "Bearer " + getToken();
    }

    // fileChanged(e) {
    //   if (e != undefined) {
    //     const config = {
    //       headers: {
    //         "Content-Type": "multipart/form-data"
    //       }
    //     };
    //     let fd = new FormData();
    //     fd.append("file", e);
    //     return Axios.post(
    //       baseURL +
    //         "core/uploader?folderId=-999&boxId=0&objectTypeId=6&objectId=0&mode=0&token=" +
    //         getToken(),
    //       fd,
    //       config
    //     ).then(res => {
    //       this.$emit('on-success',res.data.data)
    //     });
    //   }
    // }
  }
};
</script>
